import { Navigate } from 'react-router-dom'

import { ContentLoading } from 'src/components'
import { OrganizationsPage } from 'src/features/organizations'
import { useSessionContext } from 'src/hooks'

import { paths } from './paths'

/**
 * The workspace list, guarded against the empty case.
 *
 * Deleting the last workspace lands here, and so does anyone who loses access
 * to their only one — a list with nothing in it is a dead end, inside a shell
 * whose sidebar has no workspace to frame. The rule matches post-login landing
 * (`resolveWorkspaceLanding`): no workspaces means create one.
 *
 * `AuthGuard` wraps this route, so the session resolves once it has loaded.
 */
export const WorkspacesListRoute = () => {
  const { user, isLoading } = useSessionContext()

  if (isLoading || !user) {
    return <ContentLoading />
  }

  if ((user.organizations ?? []).length === 0) {
    return <Navigate to={paths.workspaces.new} replace />
  }

  return <OrganizationsPage />
}
